// @services/ReportedReview/GetRejectedReviewsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'
import { ClaimedPage} from './GetClaimedPage'

export class RejectedClaimPagesService {
  async getRejectedClaimPages(isAgency: boolean): Promise<ClaimedPage[]> {
    const api = new ScrubstrApiQueryService()

    // call the API - axios already parses JSON, so response is the array directly
    const data = await api.get<ClaimedPage[]>({
      endpoint: 'admin/claim-pages/rejected-claimed-pages',
      params: { isAgency: String(isAgency) },
    })

    // Ensure we return an array
    // Normalize and ensure we return an array with a `type` property
    return Array.isArray(data) ? data.map((item) => ({ ...(item as any), type: isAgency ? 'agency' : 'hospital' })) : []
  }
}
